import React from 'react';
import { TaxGuideDownload } from './TaxGuideDownload';

export const TaxGuideSection = () => {
  return (
    <section id="tax-guide" className="py-16 px-4 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Want a Deeper Dive Into Tax Rules?
          </h2>
          <p className="text-xl text-gray-600">
            Download our comprehensive Tax & Retirement Planning Guide—written in plain English by a CPA who specializes in reverse mortgages.
          </p>
        </div>
        
        <TaxGuideDownload />
      </div>
    </section>
  );
};
